// You can create a dApp definition in the dev console at https://stokenet-console.radixdlt.com/dapp-metadata
// then use that account for your dAppDefinitionAddress
export const dAppDefinitionAddress =
  "account_rdx129dwcgh35n829n54uaf76sjh0vmzrwnsnyt57l7ud40utwh8pc5lvt"; 